import React, {useEffect} from 'react'
import Header from '../Utilities/Header'
import Footer from '../Utilities/Footer'
import { Helmet } from 'react-helmet'


const PrivacyPolicy = () => {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div>
            <Header />
            <Helmet>
                <meta charSet="utf-8" />
                <link rel="canonical" href="https://www.wisefinserv.com/privacy-policy" />
            </Helmet>
            <div className="privacy">
                <div className="page-title">
                    <h4>Privacy Policy</h4>
                </div>
                <div className="privacy-body">
                    <p> The information contained on this website is intended for general information purpose only. The information published on this website does not constitute a solicitation, suggestions, inducement , offer or recommendation to purchase or sell any stocks, scripts of debentures, mutual funds units, shares, securities or any financial instruments or to enter into any other transaction. All the information is subject to change without notice. The information published should not be used as a substitute for any form of advice. The information on this site has not been prepared taking into account specific investment objectives, financial situations and needs of any particular investor, and therefore may not be suitable for you. Investor must consult his/her investment advisor/distributor with his investment objectives and risk taking ability.</p>                
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy
